import { render, staticRenderFns } from "./serverPopup.vue?vue&type=template&id=50c37b6a&scoped=true"
import script from "./serverPopup.vue?vue&type=script&lang=js"
export * from "./serverPopup.vue?vue&type=script&lang=js"
import style0 from "./serverPopup.vue?vue&type=style&index=0&id=50c37b6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c37b6a",
  null
  
)

export default component.exports